export default __webpack_public_path__ + "static/media/welcar04.cfe8ba03.png";